/* ==========================================================================
   NOOKISM, custom cursor (a precision-instrument feel).
   A small ink dot plus a lagging ring, both lerped toward the pointer so the
   ring trails like a drafting compass settling on a point. Morphs into a
   wide capsule with a label over links/buttons, and a plain ring over
   isometric art (a "view" cue). Desktop, fine-pointer only; respects
   reduced motion; never engages on touch.
   ========================================================================== */
(function(){
'use strict';
if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
if (window.__nkCursorBound) return;
window.__nkCursorBound = true;

var dot = document.createElement('div'); dot.className = 'nk-cur-dot';
var ring = document.createElement('div'); ring.className = 'nk-cur-ring';
var label = document.createElement('span'); label.className = 'nk-cur-label';
ring.appendChild(label);
document.addEventListener('DOMContentLoaded', mount);
if (document.readyState !== 'loading') mount();
function mount(){
  document.body.appendChild(dot);
  document.body.appendChild(ring);
  document.documentElement.classList.add('nk-cur-on');
}

var mx = -100, my = -100, rx = -100, ry = -100, live = false;
window.addEventListener('mousemove', function(e){
  mx = e.clientX; my = e.clientY;
  if (!live){ live = true; dot.classList.add('is-live'); ring.classList.add('is-live'); }
}, {passive:true});
window.addEventListener('mouseleave', function(){
  dot.classList.remove('is-live'); ring.classList.remove('is-live'); live = false;
});

function tick(){
  rx += (mx - rx) * 0.34; // tighter follow: the ring settles fast, a hint of trail, no lag
  ry += (my - ry) * 0.34;
  dot.style.transform = 'translate(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px)';
  ring.style.transform = 'translate(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px)';
  requestAnimationFrame(tick);
}
requestAnimationFrame(tick);

var current = null;
function setState(state, text){
  if (current === state) { if (text != null) label.textContent = text; return; }
  if (current) ring.classList.remove('is-' + current);
  current = state;
  if (state){ ring.classList.add('is-' + state); label.textContent = text || ''; }
  else label.textContent = '';
}
document.addEventListener('mouseover', function(e){
  var view = e.target.closest && e.target.closest('.iso, .kit-art, .nk-card-art, .ab-card-art, .media, .nk-product-stage, .uf-art, .nk-tunnel');
  var drag = e.target.closest && e.target.closest('[data-ab-compare-img], .ab-cmpimg');
  var link = e.target.closest && e.target.closest('a, button, .nk-btn, [role="button"], input, select, textarea, summary');
  if (drag) setState('drag', 'DRAG');
  else if (view) setState('view', 'VIEW');
  else if (link) setState('link', '');
  else setState(null);
});
document.addEventListener('mouseout', function(e){
  var to = e.relatedTarget;
  if (!to || !(to.closest && to.closest('.iso, .kit-art, .nk-card-art, .ab-card-art, .media, .nk-product-stage, .uf-art, .nk-tunnel, [data-ab-compare-img], .ab-cmpimg, a, button, .nk-btn, [role="button"], input, select, textarea, summary'))) setState(null);
});
document.addEventListener('mousedown', function(){ ring.classList.add('is-down'); });
document.addEventListener('mouseup', function(){ ring.classList.remove('is-down'); });
})();
